import { customAxios, customLoginAxios } from "./customAxios";


/*********************************************************************** */

/**
 * 사용자상세
 * @param {*} query 
 * @returns 
 */
// export const getUserByLoginId = async(loginId, token)=>{
//    console.log(token);
//    const res = await customAxios.get('/api/users', {params : {loginId}});
//    if (res.data) {
//       return res.data;
//    }
//    return null;
//  }

 
/*********************************************************************** */
/**
 * Enum 전체 목록
 * @returns 
 */
export const getEnumAll = async()=>{
   const res = await customAxios.get('/api/enums/');
   if (res.data) {
      return res.data;
   }
   return null;
 }

 /**
  * Code별 Enum 목록
  * @param {*} enumCode 
  * @returns 
  */
 export const getEnumsByCode = async(enumCode)=>{
   const res = await customAxios.get('/api/enums/'+enumCode);
   //console.log("===== getEnumsByCode ====");
   if (res.data) {
      return Object.values(res.data);
   }
   return null;
 }

 /**
  * Code와 Category 별 Enum 목록
  * @param {*} enumCode 
  * @param {*} category 
  * @returns 
  */
 export const getEnumsByCodeAndCategory = async(enumCode, category)=>{
   const resData = await getEnumsByCode(enumCode);
   if (resData) {
      return (resData[0].filter(data2 => data2.category === category));
   }
   return null;
 }

 /**
  * 로그인
  * @param {*} body 
  */
 export const postLogin = async(body)=>{
   //console.log(body);
   const resData = await customLoginAxios.post('/api/public/login/authenticate',body);
   //console.log(resData)
   if (resData) {
      return resData;
   }
   return null;
 }

 
 /**
  * 리프레시 토큰으로 토큰 재발급
  * @param {*} body 
  */
//  export const postRefreshToken = async(body)=>{
//    //console.log(body);
//    const resData = await customLoginAxios.post('/api/public/login/refresh',body);
//    //console.log(resData)
//    if (resData) {
//       return resData;
//    }
//    return null;
//  }

/*********************************************************************** */